export default __webpack_public_path__ + "static/media/grey-information.401f8392.svg";